import {
    mobile
} from "../Services/Agent";
import {
    wheelHandler
} from "../Services/SwipeEvents";

const showIndexScreen = (event, callback) => {
    if (!callback) return;
    let isActive = wheelHandler(event);
    if (mobile() && (event.target.className.indexOf("vote") > -1 ||
        event.target.className.indexOf("vote-container") > -1 ||
        event.target.className.indexOf("slider-item") > -1 ||
        event.target.className.indexOf("bio") > -1 ||
        event.target.className.indexOf("name") > -1 ||
        event.target.className.indexOf("desc") > -1 ||
        event.target.className.indexOf("item-container") > -1) ||
        event.target.className.indexOf("credit-spec") > -1 ||
        event.target.className.indexOf("credit-head") > -1 ||
        event.target.className.indexOf("content") > -1)
        return;

    isActive = event.type == "swd" || event.type == "swu" ? event.type === "swu" : isActive;

    callback({
        isBusy: true,
        isActive: isActive
    })
}

export {
    showIndexScreen
}


// WEBPACK FOOTER //
// ./src/Components/Helpers/Screen.js